<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">Change Last Service Date</div>
      <button class="ac-close-button" @click="toggleModal(false)">
        <img src="@shared/assets/img/general/x-black.png" alt="x" class="ac-close" />
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-body-sub-container">
        <div class="ac-input-container">
          <div class="ac-input-header">Last Service Date</div>
          <Datepicker :value="lastServiceDate" :max-date="new Date()" @input="updateTuneupDate" />
          <div
            v-if="errorObj && errorObj.tuneupDateError"
            class="sac__font-14 med tomato margin-top-4"
          >
            {{ errorObj.tuneupDateError }}
          </div>
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button type="button" class="ac-form-button" @click="updateDate()">Update</button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Updating last service date"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import Datepicker from 'v-calendar/lib/components/date-picker.umd';
import moment from 'moment';

export default {
  name: 'LastServiceModal',
  components: {
    Datepicker,
    ProcessOverlay,
  },
  props: {
    selectedProfile: Object,
    toggleModal: Function,
  },
  data() {
    const profile = structuredClone(this.selectedProfile);
    const lastServiceDate = profile?.lastServiceDate
      ? moment(profile.lastServiceDate, 'YYYY-MM-DD').toDate()
      : null;
    return {
      profile,
      lastServiceDate,
      errorObj: {},
      processing: false,
    };
  },
  methods: {
    updateTuneupDate(date) {
      this.lastServiceDate = date;
    },
    validResponse() {
      const error = {};
      if (!this.lastServiceDate) {
        error.tuneupDateError = 'Last service date is required.';
      }
      this.errorObj = error;
      return Object.keys(error).length === 0;
    },
    async updateDate() {
      if (this.validResponse()) {
        this.processing = true;
        if (
          this.profile.lastServiceDate &&
          !moment(this.profile.lastServiceDate).isSame(this.lastServiceDate) &&
          moment(this.lastServiceDate).isBefore(moment())
        ) {
          try {
            await this.$store.dispatch('createServiceLog', {
              uid: this.profile.uid,
              customerId: this.profile.customerId,
              corpId: this.profile.corpId,
              serviceType: 'Service',
              serviceDate: moment(this.lastServiceDate).format('YYYY-MM-DD'),
              serviceAddressId: this.profile.serviceAddress.id,
            });
            const filteredHvac = this.$store.state.customerDetail.filteredHvac || [];
            const updatedHvac = filteredHvac.map((hvac) => {
              if (hvac.uid === this.profile.uid) {
                return {
                  ...hvac,
                  lastServiceDate: moment(this.lastServiceDate).format('YYYY-MM-DD'),
                };
              }
              return hvac;
            });

            this.$store.dispatch('changeCustomerDetailValue', {
              field: 'filteredHvac',
              value: updatedHvac,
            });
          } catch (error) {
            console.error('Error updating last service date:', error);
          }
        }
        this.processing = false;
        this.toggleModal(false);
      }
    },
  },
};
</script>
